export default __webpack_public_path__ + "static/media/icon-SubdirectoryHub.f23c4e6d.svg";